module.exports = __webpack_public_path__ + "static/media/loader.1e87e032.mp4";